import Grid from '@mui/material/Grid';

import { DinerAuthenticationInput } from 'reservations/dinerAccount/components/DinerAuthenticationInput';
import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';
import EmailFormField from 'reservations/form/components/EmailFormField';
import NameFormField from 'reservations/form/components/NameFormField';
import PhoneNumberFormField from 'reservations/form/components/PhoneNumberFormField';

export const DinerLoginFields = () => {
  const { dinerAccountExists, isSmsAuthDisabled, setBeginAuthParams } =
    useDinerAccount();

  const handleEmailOnBlur = (value: string) => {
    if (!isSmsAuthDisabled) {
      setBeginAuthParams(value);
    }
  };

  return (
    <>
      <Grid item>
        <EmailFormField handleOnBlur={handleEmailOnBlur} />
      </Grid>
      {dinerAccountExists ? (
        <DinerAuthenticationInput />
      ) : (
        <>
          <Grid item>
            <NameFormField />
          </Grid>
          <Grid item>
            <PhoneNumberFormField />
          </Grid>
        </>
      )}
    </>
  );
};
